import {
  SET_EMAILS,
  SET_IS_LOADING_EMAIL,
  SET_IS_LOADING_REPORTS,
  SET_IS_LOADING_SFTP,
  SET_RECIPIENTS_EMAIL,
  SET_REPORTS,
  SET_SFTP,
  SET_SUBSCRIPTIONS_EMAIL,
  SET_SUBSCRIPTIONS_REPORTS,
  SET_SUBSCRIPTIONS_SFTP,
} from '../actions/report-subscriptions-page.actions';

const initialState = {
  itemsReports: [],
  isLoadingReports: false,
  metaReports: {},

  itemsEmail: [],
  isLoadingEmail: false,
  metaEmail: {},

  itemsSftp: [],
  isLoadingSftp: false,
  metaSftp: {},

  recipients: [],
  subscriptionsSftp: [],
  subscriptionsReports: [],
  subscriptionsEmail: [],
};

export default (state = initialState, action) => {
  const update = (newState) => ({ ...state, ...newState });

  switch (action.type) {
    case SET_REPORTS: {
      return update({
        itemsReports: action.payload.items || [],
        metaReports: action.payload.meta || {},
        isLoadingReports: false,
      });
    }
    case SET_EMAILS: {
      return update({
        itemsEmail: action.payload.items || [],
        metaEmail: action.payload.meta || {},
        isLoadingEmail: false,
      });
    }
    case SET_SFTP: {
      return update({
        itemsSftp: action.payload.items || [],
        metaSftp: action.payload.meta || {},
        isLoadingSftp: false,
      });
    }
    case SET_SUBSCRIPTIONS_REPORTS: {
      return update({
        subscriptionsReports: action.payload,
      });
    }
    case SET_SUBSCRIPTIONS_EMAIL: {
      return update({
        subscriptionsEmail: action.payload,
      });
    }
    case SET_SUBSCRIPTIONS_SFTP: {
      return update({
        subscriptionsSftp: action.payload,
      });
    }
    case SET_RECIPIENTS_EMAIL: {
      return update({
        recipients: action.payload,
      });
    }
    case SET_IS_LOADING_REPORTS: {
      return update({
        isLoadingReports: true,
      });
    }
    case SET_IS_LOADING_EMAIL: {
      return update({
        isLoadingEmail: true,
      });
    }
    case SET_IS_LOADING_SFTP: {
      return update({
        isLoadingSftp: true,
      });
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/reducers/report-subscriptions-page.reducer.js